import { z } from 'zod';
import * as directoryScheme from './directoryScheme';

export const crateNumberHelper =
  'Crate number is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const crateNumberSchema = directoryScheme.createNameSchema({
  name: 'Crate Number',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const crateSchema = z.object({
  id: directoryScheme.idSchema,
  crate_number: crateNumberSchema,
});

export const cratePartialSchema = crateSchema.partial({
  id: true,
});
